// extracted by mini-css-extract-plugin
module.exports = {"SmartProduct":"SmartProduct_SmartProduct__Ns7fP"};